import { Icons } from '@commenda/kakashi';
import { TWatchJobStepDefinition } from '@commenda/types';
import { useWorkflow } from '../../context/WorkflowContext';
import { TSelectedEntity } from '../../types/node';

export const WatchJobNodePropertyPanel = ({
  selectedEntity,
}: {
  selectedEntity: TSelectedEntity;
}) => {
  const { workflow } = useWorkflow();

  const selectedStep = workflow?.steps.find(
    (step) => step.id === selectedEntity.id
  ) as TWatchJobStepDefinition | undefined;

  const isConfigured = Boolean(
    selectedStep?.jobIdProvider && selectedStep?.asyncToolName
  );

  return (
    <div className="flex flex-col gap-lg">
      <span className="txt-small-regular text-text-secondary">
        Waits for the background job started by the previous step to finish
        before the workflow continues. If the job fails or takes too long, the
        workflow stops and is flagged for attention.
      </span>

      <div className="flex items-center gap-md rounded-md bg-bg-secondary px-lg py-md">
        <Icons.ClockRefresh className="size-4 text-text-tertiary shrink-0" />
        <span className="txt-small-regular text-text-secondary">
          {isConfigured
            ? `Waiting on ${selectedStep?.asyncToolName}. Configured automatically — nothing to set up here.`
            : 'This step is configured automatically when the workflow is saved.'}
        </span>
      </div>
    </div>
  );
};
